import { render } from "./RatingBarRank1.vue?vue&type=template&id=1d6f2506&scoped=true"
const script = {}

import "./RatingBarRank1.vue?vue&type=style&index=0&id=1d6f2506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6f2506"]])

export default __exports__